import PropTypes from 'prop-types';
import React from 'react';

function AppStatusOption({ value, isSelected, onClick, label, children }) {
    return (
        <div
            className={`${isSelected ? 'ast-app-status-chooser__option--selected ' : ''}ast-app-status-chooser__option`}
            onClick={() => onClick(value)}
        >
            <p className="ast-app-status-chooser__option-title">{label}</p>
            <p className="ast-app-status-chooser__option-description">{children}</p>
        </div>
    );
}

AppStatusOption.propTypes = {
    value: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
};

export default AppStatusOption;
